import {CardInfoContent} from '../../../../components/CardInfoGuide/CardInfoGuide'

const salesReportInfo: CardInfoContent = {
  title: 'Vendas no período',
  subtitle: 'Métrica do relatório',
  items: [
    {
      label: 'O que mostra',
      description:
        'Soma do valor total dos pedidos no período filtrado. O subtexto indica quantos pedidos entram nessa soma.',
    },
  ],
}

const earnedReportInfo: CardInfoContent = {
  title: 'Cashback gerado',
  subtitle: 'Métrica do relatório',
  items: [
    {
      label: 'O que mostra',
      description:
        'Soma das movimentações de acúmulo no período. O subtexto mostra quantos acúmulos foram registrados.',
    },
  ],
}

const redeemedReportInfo: CardInfoContent = {
  title: 'Cashback resgatado',
  subtitle: 'Métrica do relatório',
  items: [
    {
      label: 'O que mostra',
      description:
        'Soma das movimentações de resgate no período. O percentual compara o resgatado com o gerado no mesmo intervalo.',
    },
    {
      label: 'Pode passar de 100%',
      description:
        'Isso acontece quando o cliente usa saldo acumulado em períodos anteriores, não só o cashback gerado nas datas filtradas.',
    },
  ],
}

const leftoverReportInfo: CardInfoContent = {
  title: 'Deixado de gerar',
  subtitle: 'Estimativa da taxa base',
  items: [
    {
      label: 'O que mostra',
      description:
        'Diferença entre o cashback que a taxa base poderia gerar nas vendas do período e o valor que de fato foi acumulado.',
    },
    {
      label: 'Como é calculado',
      description:
        'Aplica a taxa base sobre as vendas, respeitando pedido mínimo e teto por pedido. Regras específicas de produto, categoria, catálogo ou variação não entram nesse cálculo.',
    },
    {
      label: 'Por que pode ser R$ 0,00',
      description:
        'Se o cashback gerado (incluindo regras específicas) for maior que a estimativa da taxa base, não há valor deixado de gerar.',
    },
  ],
}

const leftoverReportInfoFood: CardInfoContent = {
  title: 'Deixado de gerar',
  subtitle: 'Estimativa da taxa base',
  items: [
    {
      label: 'O que mostra',
      description:
        'Diferença entre o cashback que a taxa base poderia gerar nas vendas do período e o valor que de fato foi acumulado.',
    },
    {
      label: 'Como é calculado',
      description:
        'Aplica a taxa base sobre as vendas, respeitando pedido mínimo e teto por pedido. Regras específicas de produto ou categoria não entram nesse cálculo.',
    },
    {
      label: 'Por que pode ser R$ 0,00',
      description:
        'Se o cashback gerado (incluindo regras específicas) for maior que a estimativa da taxa base, não há valor deixado de gerar.',
    },
  ],
}

const reversalReportInfo: CardInfoContent = {
  title: 'Estornos',
  subtitle: 'Métrica do relatório',
  items: [
    {
      label: 'O que mostra',
      description:
        'Soma das movimentações de estorno no período, quando o cashback gerado é revertido.',
    },
  ],
}

const ordersWithCashbackInfo: CardInfoContent = {
  title: 'Pedidos com cashback',
  subtitle: 'Métrica do relatório',
  items: [
    {
      label: 'O que mostra',
      description:
        'Quantidade de pedidos distintos que tiveram alguma movimentação de cashback no período, em relação ao total de vendas.',
    },
  ],
}

const avgTicketInfo: CardInfoContent = {
  title: 'Ticket médio',
  subtitle: 'Métrica do relatório',
  items: [
    {
      label: 'Ticket médio',
      description:
        'Valor médio dos pedidos: vendas do período divididas pela quantidade de pedidos.',
    },
    {
      label: 'Média de cashback',
      description:
        'Cashback gerado dividido pelos pedidos que tiveram cashback. Não usa o total de vendas.',
    },
  ],
}

const customersBalanceInfo: CardInfoContent = {
  title: 'Clientes e saldo',
  subtitle: 'Métrica do relatório',
  items: [
    {
      label: 'Clientes',
      description:
        'Quantidade de clientes distintos com movimentação de cashback no período filtrado.',
    },
    {
      label: 'Saldo atual',
      description:
        'Soma do saldo atual das carteiras desses clientes. Esse valor é o saldo de agora, não só o saldo gerado no período.',
    },
  ],
}

const variationRulesInfo: CardInfoContent = {
  title: 'Regras de Variação',
  subtitle: 'Regras ativas',
  items: [
    {
      label: 'O que mostra',
      description:
        'Quantidade de regras de variação ativas neste momento. Esse número não muda com o filtro de datas.',
    },
  ],
}

const productRulesInfo: CardInfoContent = {
  title: 'Regras de Produto',
  subtitle: 'Regras ativas',
  items: [
    {
      label: 'O que mostra',
      description:
        'Quantidade de regras de produto ativas neste momento. Esse número não muda com o filtro de datas.',
    },
  ],
}

const categoryRulesInfo: CardInfoContent = {
  title: 'Regras de Categoria',
  subtitle: 'Regras ativas',
  items: [
    {
      label: 'O que mostra',
      description:
        'Quantidade de regras de categoria ativas neste momento. Esse número não muda com o filtro de datas.',
    },
  ],
}

const catalogRulesInfo: CardInfoContent = {
  title: 'Regras de Catálogo',
  subtitle: 'Regras ativas',
  items: [
    {
      label: 'O que mostra',
      description:
        'Quantidade de regras de catálogo ativas neste momento. Esse número não muda com o filtro de datas.',
    },
  ],
}

const trendReportInfo: CardInfoContent = {
  title: 'Evolução no período',
  subtitle: 'Gráfico',
  items: [
    {
      label: 'Valores',
      description:
        'Vendas, cashback gerado e cashback resgatado agrupados por dia, mês ou ano.',
    },
    {
      label: 'Clientes',
      description:
        'Quantos clientes fizeram o primeiro resgate neste período versus quem já tinha resgatado nele. Não indica o primeiro resgate da vida do cliente.',
    },
  ],
}

const topCustomersInfo: CardInfoContent = {
  title: 'Clientes com mais cashback',
  subtitle: 'Ranking',
  items: [
    {
      label: 'O que mostra',
      description:
        'Os 20 clientes com maior acúmulo de cashback no período. Gerado e resgatado consideram só as movimentações das datas filtradas.',
    },
  ],
}

const ticketCompareInfo: CardInfoContent = {
  title: 'Ticket com vs sem resgate',
  subtitle: 'Eficácia do programa',
  items: [
    {
      label: 'O que mostra',
      description:
        'Compara o valor médio dos pedidos em que o cliente usou cashback com o valor médio dos pedidos sem resgate, no período filtrado.',
    },
    {
      label: 'Não é um teste A/B',
      description:
        'É uma comparação observacional. Quem resgata pode já ser um cliente com ticket maior, então o número indica tendência, não prova causalidade.',
    },
  ],
}

const checkoutShareInfo: CardInfoContent = {
  title: 'Participação no checkout',
  subtitle: 'Eficácia do programa',
  items: [
    {
      label: 'O que mostra',
      description:
        'Quanto o cashback resgatado representou das vendas do período. Exemplo: se as vendas foram R$ 10.000 e o resgate foi R$ 400, a participação é 4%.',
    },
  ],
}

const salesPerRedeemedInfo: CardInfoContent = {
  title: 'Vendas por real resgatado',
  subtitle: 'Eficácia do programa',
  items: [
    {
      label: 'O que mostra',
      description:
        'Soma dos pedidos que tiveram resgate dividida pelo cashback resgatado. Diz quanto de venda veio junto de cada R$ 1 usado de saldo.',
    },
    {
      label: 'Não é ROI incremental',
      description:
        'O cliente poderia ter comprado mesmo sem o saldo. Use como referência de volume associado ao resgate, não como retorno comprovado da campanha.',
    },
  ],
}

const avgRedeemTimeInfo: CardInfoContent = {
  title: 'Tempo médio de resgate',
  subtitle: 'Eficácia do programa',
  items: [
    {
      label: 'O que mostra',
      description:
        'Média de dias entre um acúmulo e o próximo resgate do mesmo cliente, só com movimentações do período filtrado.',
    },
    {
      label: 'Para que serve',
      description:
        'Ajuda a calibrar o prazo de validade do crédito. Se o cliente volta em 10 dias e a validade é 90, o prazo pode estar folgado demais.',
    },
  ],
}

const ruleInfoByScope: Record<string, CardInfoContent> = {
  variation: variationRulesInfo,
  product: productRulesInfo,
  category: categoryRulesInfo,
  catalog: catalogRulesInfo,
}

export {
  salesReportInfo,
  earnedReportInfo,
  redeemedReportInfo,
  leftoverReportInfo,
  leftoverReportInfoFood,
  reversalReportInfo,
  ordersWithCashbackInfo,
  avgTicketInfo,
  customersBalanceInfo,
  ruleInfoByScope,
  trendReportInfo,
  topCustomersInfo,
  ticketCompareInfo,
  checkoutShareInfo,
  salesPerRedeemedInfo,
  avgRedeemTimeInfo,
}
